import {useCallback, useContext} from 'react';
import {AppModelContext} from '../components/app';

export const useTranslations = (i18n?: Record<string, string>) => {
  const dictionary = i18n ? i18n : useContext(AppModelContext).i18n;
  const translate = useCallback(
    (key: string) => {
      return dictionary[key] || key;
    },
    [dictionary],
  );

  return translate;
};
